"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _devConsoleLog = require("../_util/devConsoleLog");
var _utils = require("../_util/utils");
var _radio = _interopRequireDefault(require("../radio"));
var _jsxRuntime = require("react/jsx-runtime");
const checkChildren = Element => {
  if (! /*#__PURE__*/_react.default.isValidElement(Element) || Element.type.name !== _radio.default.name) {
    (0, _devConsoleLog.error)(true, 'RadioGroup', 'The "RadioGroup" children must be "Radio".');
    return false;
  } else if (Element.props.value === undefined) {
    (0, _devConsoleLog.error)(true, 'RadioGroup', '"Radio" as a "RadioGroup" children must have a "value" attribute.');
    return false;
  }
  return true;
};
const RadioGroup = props => {
  const {
    disabled,
    children,
    className,
    style,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉

    ...restProps
  } = props;
  const [value, onChange] = (0, _ahooks.useControllableValue)(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const baseClassName = "".concat(prefixClass, "-radioGroup");
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...attrs.data,
    className: (0, _classnames.default)(baseClassName, className),
    style: style,
    children: _react.default.Children.map(children, radio => {
      return checkChildren(radio) && /*#__PURE__*/_react.default.cloneElement(radio, {
        disabled: disabled !== null && disabled !== void 0 ? disabled : radio.props.disabled,
        onChange: checked => {
          checked && onChange(radio.props.value);
        },
        checked: radio.props.value === value
      });
    })
  });
};
var _default = exports.default = RadioGroup;